import DOMPurify from 'dompurify';

// Keep links that the institution authored as "open in new tab" working, while
// forcing the safe rel pair so the new tab cannot reach back into our window.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

// Rich HTML curated by staff (FERPA warning, API error messages). Allows the
// semantic/formatting tags DOMPurify whitelists by default plus anchor targets.
export const sanitizeRich = (html) =>
    DOMPurify.sanitize(html, {
        ADD_ATTR: ['target'],
    });

// Search typeahead highlighting: matched text is wrapped in a styled <span>
// (see highlightText). Keep that span plus its inline style, drop everything else.
export const sanitizeHighlight = (html) =>
    DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['mark', 'span'],
        ALLOWED_ATTR: ['style'],
    });

// Handlebars-compiled print/PDF documents render a full HTML document with an
// inline <style> block. Preserve the document structure and styles so the export
// keeps its layout, while still dropping script-style injection vectors.
export const sanitizeDocument = (html) =>
    DOMPurify.sanitize(html, {
        WHOLE_DOCUMENT: true,
        ADD_TAGS: ['style'],
        ADD_ATTR: ['target'],
        FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
    });
